import * as api from '../../api'
import request from '../../request'


const selectByOne = data => {
  return request({
    url : api.selectByOne,
    method : 'get',
    params : data
  })
}

export default {
  selectByOne,
} 